import React from 'react'
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ActionsContextV2 from '../ActionsContextV2';
import CheckIcon from "@material-ui/icons/Check";

const Container = styled.div`

display:flex;
align-items:center;
flex-direction:column;
text-align:center;
`
const Title = styled.div`


padding-top:60px;
font-family: Roboto;
font-weight: 700;
font-size:18px;
color:#5F5F5F
padding-bottom:20px;

`
const Subtitle = styled.div`

font-family: Roboto;
font-weight: 400;
font-size:18px;
color:#5F5F5F;
padding-bottom:20px;

`

const Caption = styled.div`

font-family: Roboto;
font-weight: 400;
font-size:14px;
color:#5F5F5F
padding-bottom:20px;

`

const CheckContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
width:100px;
height:100px;
border-radius:50px;
border:3px solid #304a57;
margin-top:75px;
marning-bottom:20px
`

const ActionOneTimeDeviationCompletedV2 = props => {


    const context = React.useContext(ActionsContextV2);
    
    let level2Approver = "the Level 2 approver"
    const step2 = context.actionsRedux.selectedProjectFunctionDetails.masterWorkflowSteps[1];

    if(step2)
    {
        level2Approver = step2.assignee;

        var nameArr = level2Approver.split(',');

        if(nameArr.length > 1)
        {
            level2Approver = `${nameArr[1]} ${nameArr[0]}`
        }

    }



    return(
        <Container>
            <CheckContainer>
                <CheckIcon fontSize="large" color="primary"/>
            </CheckContainer>
            <Title>
                One-Time Deviation Request Sent Successfully
            </Title>
            <Subtitle>
                {`This will appear as a pending approval in ${level2Approver}'s list.`}
            </Subtitle>


        </Container>
    );


}


export default ActionOneTimeDeviationCompletedV2;